// React
import React from "react";

import { ThemeProvider } from "@mui/material/styles";
// MUI
import { LicenseInfo } from "@mui/x-license";

import { SnackbarProvider } from "notistack";
import Routing from "routes";
// Third party imports
import { theme } from "themes.jsx";

// Components
import NotificationSnackbar from "components/NotificationSnackbar";
import SnackbarContainer from "components/SnackbarContainer";
import { ContextMenuProvider } from "components/ui/ContextMenu";
import ShortcutsHelp from "components/ui/ShortcutsHelp";

// Hooks
import { useInitAuth, useLoginDataTransfer } from "hooks/useAuthDataTransfer.jsx";
import useUrlCleaner from "hooks/controls/useUrlCleaner.jsx";

// Styles: Tailwind, design tokens and shared classes, loaded once for the whole app
import "styles/global.css";

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE);
function App() {
  // Handle login and logout data transfer if required
  useLoginDataTransfer();
  // Init isAuth & refresh
  useInitAuth();
  // Handle null in the urlgit push
  useUrlCleaner();

  return (
    <SnackbarProvider maxSnack={5}>
      <ThemeProvider theme={theme}>
        {/* The app's single context menu (right-click, Shift+F10, ⋮ buttons) */}
        <ContextMenuProvider>
          <Routing />
          {/* "?" opens the list of keyboard shortcuts */}
          <ShortcutsHelp />
        </ContextMenuProvider>
        <NotificationSnackbar />
        <SnackbarContainer />
      </ThemeProvider>
    </SnackbarProvider>
  );
}
export default App;
